import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';

import BasePageUAM from '../BasePageUAM/BasePageUAM';
import { getLoginURL } from '../../utils/redirect-utils';
import Step2RegistrationPanel from './Panels/Step2RegistrationPanel/Step2RegistrationPanel';
import RegistrationCompletePanel from '../../shared-panels/uam/RegistrationCompletePanel/RegistrationCompletePanel';
import BusyOverlay from '../../shared-panels/uam/BusyOverlay/BusyOverlay';

const RegistrationStep2Page = ({ brand, destPath }) => {
  const [isBusy, setIsBusy] = useState(false);
  const [completedUser, setCompletedUser] = useState(null);
  const [isEmailVerified, setIsEmailVerified] = useState(false);
  const isNewRegistration = useRef(localStorage.getItem('is_new_registration') === 'true');

  const handleGoToLogin = () => {
    window.location.href = getLoginURL(destPath);
  };

  if (isNewRegistration.current) {
    localStorage.removeItem('is_new_registration');
  }

  return (
    <BasePageUAM activeTab={2} brand={brand} destPath={destPath} needsDestPath showTabs={!completedUser}>
      { isBusy && <BusyOverlay /> }
      {
        completedUser
          ? (
            <RegistrationCompletePanel
              email={completedUser.email}
              isPriorRegistration={false}
              isEmailVerified={isEmailVerified}
              onGoToLogin={handleGoToLogin}
            />
          )
          : (
            <Step2RegistrationPanel
              brand={brand}
              destPath={destPath}
              setCompletedUser={setCompletedUser}
              isNewRegistration={isNewRegistration.current}
              setIsBusy={setIsBusy}
              setIsEmailVerified={setIsEmailVerified}
            />
          )
      }
    </BasePageUAM>
  );
};

RegistrationStep2Page.propTypes = {
  brand: PropTypes.object.isRequired,
  destPath: PropTypes.object.isRequired,
};

export default RegistrationStep2Page;
